<header>
  <div class="container">
    <div class="navbar-brand">
      <div class="header-logo"><img [src]="['assets/HCUS-logo-300x300px.png']" alt="HC Logo"></div>
      <div class="Brand-title"> What's new {{title}}?</div>
    </div>
    <div class="admin-button" *ngIf="!authenticated || authenticated && !inAdmin">
      <a class="btn btn-admin" routerLink="/administration">Admin Access</a>
    </div>
    <div [className]="!inAdmin?'logout-button':'admin-button'" class="logout-button" *ngIf="authenticated">
      <a class="btn btn-admin" routerLink="/logout">Log Out</a>
    </div>
  </div>
</header>
<app-breadcrumb></app-breadcrumb>
<app-alert></app-alert>
<router-outlet></router-outlet>
<footer></footer>
